export default "__VITE_ASSET__cede6a10__"